import request from '@/utils/request'

// 联盟申请列表
export const listAlliance = (pageData, formData) => {
    return request.post(`/alliance/application/page/${pageData.page}/${pageData.pageSize}`, formData);
};

// 联盟申请-跟进确认|跟进取消
export const updateAllianceAssignee = (allianceApplicationId, isFollowedUp) => {
    return request.put(`/alliance/application/assignee/${allianceApplicationId}/${isFollowedUp}`)
}
